import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL, APIURLCOT } from "../../../Config";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";

export default function BookDemo() {
  const token = localStorage.getItem("token");

  const todayDate = new Date().toISOString().split("T")[0];
  const firstOfMonth = new Date();
  firstOfMonth.setDate(1);
  const formattedStartDate = firstOfMonth.toISOString().split("T")[0];

  const [activeTab, setActiveTab] = useState("book");
  const [isLoader, setIsLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [currentDemo, setCurrentDemo] = useState(null);

  const [bookDemos, setBookDemos] = useState([]);
  const [replyDemos, setReplyDemos] = useState([]);

  useEffect(() => {
    fetchDemos();
  }, []);

  const fetchDemos = () => {
    setIsLoader(true);
    axios
      .get(`${APIURL}/demoReportbydate/${formattedStartDate}/${todayDate}`, {
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setIsLoader(false);
        const all = res.data;
        setBookDemos(all.filter((item) => !item.replymessage));
        setReplyDemos(all.filter((item) => item.replymessage));
      })
      .catch((err) => {
        setIsLoader(false);
        console.log(err);
        toast.error("Failed to fetch demo requests");
      });
  };

  const submitReply = () => {
    if (!currentDemo || !message) {
      toast.warning("Please enter a reply message");
      return;
    }

    const data = JSON.stringify({
      replyby: "Admin",
      id: currentDemo.id || 0,
      replymessage: message,
    });

    setIsLoader(true);
    axios
      .post(`${APIURLCOT}/reply`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setIsLoader(false);
        setShowModal(false);
        setMessage("");
        toast.success("Reply submitted successfully");
        fetchDemos();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
        toast.error("Failed to submit reply");
      });
  };

  const renderTableRows = (data, isReplyTab = false) =>
    data.map((demo, index) => (
      <tr key={demo.id}>
        <td>{index + 1}</td>
        <td>{moment(demo.entrydate).format("DD-MM-YYYY ")}</td>
        <td>{demo.name}</td>
        <td>{demo.mobileno}</td>
        <td>{demo.emailid}</td>
        <td>{demo.organizationName}</td>
        {!isReplyTab && <td>{demo.teamSize}</td>}
        <td>{demo.message}</td>
        {isReplyTab ? (
          <>
            <td>{demo.replymessage}</td>
            {/* <td>{moment(demo.entrydate).format("hh:mm A")}</td> */}
          </>
        ) : (
          <>
            <td>
              <button
                className="btn btn-success"
                onClick={() => {
                  setCurrentDemo(demo);
                  setShowModal(true);
                }}
              >
                Close
              </button>
            </td>
            {/* <td>
              <span className="text-warning">Pending</span>
            </td> */}
          </>
        )}
      </tr>
    ));

  return (
    <div className="p-3">
      <h4>Demo Requests</h4>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "book" ? "active" : ""}`}
            onClick={() => setActiveTab("book")}
          >
            Pending
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "reply" ? "active" : ""}`}
            onClick={() => setActiveTab("reply")}
          >
            Closed
          </button>
        </li>
      </ul>

      {isLoader ? (
        <div className="d-flex justify-content-center my-5">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="pt-3">
          <div className="card">
            <div className="table-responsive mt-3 p-3">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>Organization</th>
                    {!activeTab.includes("reply") && <th>Team Size</th>}
                    <th>Message</th>
                    {activeTab === "reply" ? (
                      <>
                        <th>Close (remark)</th>
                        {/* <th>Reply Time</th> */}
                      </>
                    ) : (
                      <>
                        <th style={{ textAlign: "center" }}>Close (remark)</th>
                        {/* <th>Status</th> */}
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {activeTab === "book"
                    ? renderTableRows(bookDemos)
                    : renderTableRows(replyDemos, true)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Reply Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Reply to Demo Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Enter your reply message..."
          />
          <div className="d-flex mt-3 justify-content-end">
            <button
              className="btn btn-secondary mr-2"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button className="btn btn-success" onClick={submitReply}>
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
